class Highlighter
{

  // private variables

  constructor(id) {
    this.targetNode = document.getElementById(id) || document.body;
    this.hiliteTag = 'MARK';
    this.skipTags = new RegExp('^(?:' + this.hiliteTag + '|SCRIPT|FORM|SPAN)$');
    this.colors = ['#ffff00'];
    this.wordColor = ['#000000'];
    this.colorIdx = 0;
    this.matchRegExp = '';

    // characters to strip from start and end of the input string
    this.endRegExp = new RegExp('^[^\\w]+|[^\\w]+$', 'g');

    // characters used to break up the input string into words
    this.breakRegExp = new RegExp('[^\\w\'-]+', 'g');
}



  setEndRegExp(regex) {
    this.endRegExp = regex;
  }

  setBreakRegExp(regex) {
    this.breakRegExp = regex;
    return this.breakRegExp;
  }

  setMatchType(type)
  {
    switch(type)
    {
      case 'left':
        this.openLeft = false;
        this.openRight = true;
        break;

      case 'right':
        this.openLeft = true;
        this.openRight = false;
        break;

      case 'open':
        this.openLeft = this.openRight = true;
        break;

      default:
        this.openLeft = this.openRight = false;

    }
  }

  setRegex(input)
  {
    input = input.replace(this.endRegExp, '');
    input = input.replace(this.breakRegExp, '|');
    input = input.replace(/^\||\|$/g, '');
    if(input) {
      var re = '(' + input + ')';
      if(!this.openLeft) {
        re = '\\b' + re;
      }
      if(!this.openRight) {
        re = re + '\\b';
      }
      this.matchRegExp = new RegExp(re, 'i');
      return this.matchRegExp;
    }
    return false;
  }

  getRegex()
  {
    var retval = this.matchRegExp.toString();
    retval = retval.replace(/(^\/(\\b)?|\(|\)|(\\b)?\/i$)/g, '');
    retval = retval.replace(/\|/g, ' ');
    return retval;
  }

  // recursively apply word highlighting
  hiliteWords(node)
  {
    if(node === undefined || !node) return;
    if(!this.matchRegExp) return;
    if(this.skipTags.test(node.nodeName)) return;

    if(node.hasChildNodes()) {
      for(var i=0; i < node.childNodes.length; i++)
        this.hiliteWords(node.childNodes[i]);
    }
    if(node.nodeType == 3) { // NODE_TEXT

      var nv, regs;

      if((nv = node.nodeValue) && (regs = this.matchRegExp.exec(nv))) {

        if(!this.wordColor[regs[0].toLowerCase()]) {
          this.wordColor[regs[0].toLowerCase()] = this.colors[this.colorIdx++ % this.colors.length];
        }

        var match = document.createElement(this.hiliteTag);
        match.appendChild(document.createTextNode(regs[0]));
        match.style.backgroundColor = this.wordColor[regs[0].toLowerCase()];
        match.style.color = '#000';
        match.style.padding = '0';

        var after = node.splitText(regs.index);
        after.nodeValue = after.nodeValue.substring(regs[0].length);
        node.parentNode.insertBefore(match, after);

      }
    }
  }

  // remove highlighting
  remove()
  {
    var arr = document.getElementsByTagName(this.hiliteTag), el;
    while(arr.length && (el = arr[0])) {
      var parent = el.parentNode;
      parent.replaceChild(el.firstChild, el);
      parent.normalize();
    }
  }

  // start highlighting at target node
  apply(input)
  {
    this.remove();
    if(input === undefined || !(input = input.replace(/(^\s+|\s+$)/g, ''))) {
      return;
    }
    if(this.setRegex(input)) {
      this.hiliteWords(this.targetNode);
    }
    return this.matchRegExp;
  }
}

export default Highlighter;



// WEBPACK FOOTER //
// ./scripts/util/Highlighter.js